'use client';
import { toCamelCaseObj } from '@utils';
import { RInstituteBranding } from '../types/branding';
import { defaultTheme } from '../utils/constants';
import { masterDataEndpoints, masterDataFetcher } from './fetchers';

export async function getBrandingByInstitute(instituteID: string) {
  let response;
  try {
    response = await masterDataFetcher.get<RInstituteBranding>(
      `${masterDataEndpoints.branding}${instituteID}/`
    );
  } catch (error) {
    console.log({ error });
    return toCamelCaseObj(defaultTheme.data);
  }
  const { data } = response;
  return toCamelCaseObj(data.data);
}
